import React, { Fragment } from 'react';
import { getFullName } from '../utils/getFullName';
import { getOrganizationNameById } from '../utils/getOrganizationNameById';
import { getOrganizationNumberById } from '../utils/getOrganizationNumberById';

const LoggedInButtonContent = ({ meData, organizationData, selectedOrganizationId }) => {
    const { firstName, middleName, lastName } = meData;
    const fullName = getFullName(firstName, middleName, lastName);
    const organizations = organizationData ? organizationData.organizations : [];
    const organizationName = getOrganizationNameById(organizations, selectedOrganizationId);
    const relationNumber = getOrganizationNumberById(organizations, selectedOrganizationId)

    return (
        <Fragment>
            {fullName}
            {organizationName && <span>{relationNumber} - {organizationName}</span>}
        </Fragment>
    );
};

export { LoggedInButtonContent };
